/* eslint-disable react/require-default-props */
/* eslint-disable react/no-danger */
import React from 'react';
import { translate } from '@utils/i18n';
import { Text } from '@ui';
import camelToCapitalize from '@utils/functions/camelToCapitalize';
import { humanizeInspectableType, isKnownAssetType } from '../../utils/humanizeInspectableType';
import getLocalizedQuestionText from '../../utils/getLocalizedQuestionText';
import getCurrentLanguage from '../../utils/getCurrentLanguage';
import { IssueStatusEnum } from '../../types';
import ManagerNote from './ManagerNote';
import IssueLayout from './IssueLayout';
import './styles.scss';
import DeviceInfoToggle from './DeviceInfoToggle';
export default function MissingDeficiencyNotePhotoCard({ issue, defaultExpanded, onToggle, onUpdateIssue, onUndoAction, onDeviceInfoToggle, readOnly = false, settings }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const status = issue.status || IssueStatusEnum.Detected;
    const userLanguage = getCurrentLanguage();
    const isHighImpact = issue.status !== IssueStatusEnum.Resolved && ((_a = issue.issueData) === null || _a === void 0 ? void 0 : _a.highImpact) === true;
    // Handler functions for issue actions
    const handleSuggestCorrection = () => {
        onUpdateIssue(issue.id, status, true);
    };
    const handleDismissIssue = () => {
        onUpdateIssue(issue.id, IssueStatusEnum.DismissedByBackOffice, false);
    };
    const handleNoteChange = (note) => {
        onUpdateIssue(issue.id, status, issue.markedForSuggestion, note);
    };
    // Create high impact badge if needed
    const highImpactBadge = isHighImpact ? (React.createElement("span", { className: "issue-card__badge issue-card__badge--high-impact" }, translate('high_impact', { namespace: 'features.iim_review.issue_card' }))) : undefined;
    return (React.createElement(IssueLayout, { issueType: "missing_deficiency_notes_and_photos", badge: highImpactBadge, status: status, defaultExpanded: defaultExpanded, onToggle: onToggle, onSuggestCorrection: handleSuggestCorrection, onDismissIssue: handleDismissIssue, onUndoAction: onUndoAction, readOnly: readOnly, statusChanges: issue.statusChanges, isMultitech: issue.isMultitech, technician: issue.technician, markedForSuggestion: issue.markedForSuggestion },
        React.createElement(React.Fragment, null,
            React.createElement("p", null,
                React.createElement("span", { dangerouslySetInnerHTML: {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        __html: translate('missing_deficiency_notes_photos', {
                            namespace: 'features.iim_review.issue_card',
                            deficiencyId: (_b = issue.deficiency) === null || _b === void 0 ? void 0 : _b.id,
                            missingType: issue.issueData.missing
                        })
                    } }),
                issue.question && issue.inspectable && isKnownAssetType((_c = issue.inspectable) === null || _c === void 0 ? void 0 : _c.type) && (React.createElement(React.Fragment, null,
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("b", null,
                        ((_d = issue.question) === null || _d === void 0 ? void 0 : _d.type) && camelToCapitalize(issue.question.type),
                        " /",
                        ' ',
                        humanizeInspectableType((_e = issue.inspectable) === null || _e === void 0 ? void 0 : _e.type)),
                    React.createElement("br", null),
                    React.createElement("span", null, getLocalizedQuestionText(issue.question, userLanguage))))),
            ((_g = (_f = issue.deficiency) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.notes) && (React.createElement("div", { className: "issue-card__deficiency-notes" },
                React.createElement(Text, { variant: "x-small", as: "p", className: "issue-card__deficiency-notes-title" }, translate('deficiency_notes_label', { namespace: 'features.iim_review.issue_card' })),
                React.createElement(Text, { variant: "body", as: "p", className: "issue-card__deficiency-notes-content" }, issue.deficiency.data.notes))),
            React.createElement(DeviceInfoToggle, { inspectable: issue.inspectable, onToggle: onDeviceInfoToggle }),
            issue.markedForSuggestion && (!readOnly || ((_h = issue.managerNote) === null || _h === void 0 ? void 0 : _h.trim())) && (React.createElement("div", { className: "issue-card__body" },
                React.createElement(ManagerNote, { note: issue.managerNote || '', onNoteChange: handleNoteChange, disabled: readOnly }))))));
}
